import {
  EditRuleBinding,
  EditRuleCondition,
  EditRulePattern,
  EditRuleSet,
} from "../../../../domain/document";
import {
  IEditRuleSetBean,
  IEditRuleSetBindingBean,
  IEditRuleSetConditionBean,
  IEditRuleSetPatternBean,
} from "../beans";

export class EditRuleSetTranslator {
  static toEditRuleSet(bean: IEditRuleSetBean): EditRuleSet {
    if (!bean) { return null; }

    const editRuleSet = new EditRuleSet();
    editRuleSet.patterns = bean.patterns.map(p => this.toEditRulePattern(p));
    return editRuleSet;
  }

  private static toEditRulePattern(bean: IEditRuleSetPatternBean): EditRulePattern {
    const pattern = new EditRulePattern();
    pattern.conditions = bean.conditions.map(c => this.toEditRuleCondition(c));
    pattern.bindings = bean.bindings.map(b => this.toEditRuleBinding(b));
    return pattern;
  }

  private static toEditRuleCondition(bean: IEditRuleSetConditionBean): EditRuleCondition {
    const condition = new EditRuleCondition();
    condition.professionCode = bean.professionCode;
    condition.projectTeamId = bean.projectTeamId;
    condition.uneditable = bean.uneditable;
    condition.emptyCheck = bean.emptyCheck;
    return condition;
  }

  private static toEditRuleBinding(bean: IEditRuleSetBindingBean): EditRuleBinding {
    const binding = new EditRuleBinding();
    binding.objectTitle = bean.objectTitle;
    binding.objectName = bean.objectName;
    binding.objectSubName = bean.objectSubName;
    return binding;
  }
}
